<template lang="pug">
  v-row
    v-col
      image-upload(
        label="Изображениее"
        ref="image"
        existing-image-url="http://localhost:8080/img/course-sample.2f79df02.png"
      )
      v-btn(@click="testUpload") test upload

</template>

<script>
import ImageUpload from '@/components/InputFields/ImageUpload.vue';

export default {
  name: 'Testpage',
  components: { ImageUpload },
  methods: {
    testUpload() {
      this.$refs.image.uploadFile()
        .then((r) => { console.log(r); });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
